var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "110x110 My Service") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,21V65H75V21ZM73,63H37V23H73Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22.33,
    r: 3.23,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.85,40.92a.57.57,0,0,0-.38-.23l-3.34-.51a10.69,10.69,0,0,0-.75-1.79c.22-.3.55-.73,1-1.28s.74-1,.93-1.21a.78.78,0,0,0,.14-.42.62.62,0,0,0-.12-.4,25.27,25.27,0,0,0-3-3.1.72.72,0,0,0-.46-.18.56.56,0,0,0-.43.16l-2.59,1.95a11.69,11.69,0,0,0-1.64-.67l-.51-3.35a.55.55,0,0,0-.21-.4.72.72,0,0,0-.45-.15H53a.62.62,0,0,0-.66.51,30.77,30.77,0,0,0-.53,3.39,10.39,10.39,0,0,0-1.66.69L47.62,32a.79.79,0,0,0-.47-.18c-.27,0-.85.43-1.73,1.3a17.26,17.26,0,0,0-1.79,2,.79.79,0,0,0-.17.42.74.74,0,0,0,.19.44c.81,1,1.46,1.82,2,2.51a8.62,8.62,0,0,0-.71,1.68l-3.39.51a.53.53,0,0,0-.35.23.7.7,0,0,0-.14.42v4a.67.67,0,0,0,.14.43.6.6,0,0,0,.38.22l3.34.5a9.07,9.07,0,0,0,.75,1.8c-.22.3-.55.73-1,1.28s-.75,1-.93,1.22a.66.66,0,0,0-.14.42.73.73,0,0,0,.12.41,24.62,24.62,0,0,0,3,3.07.65.65,0,0,0,.91,0l2.57-2a11.22,11.22,0,0,0,1.64.68l.51,3.35a.51.51,0,0,0,.21.39.73.73,0,0,0,.45.16h4a.62.62,0,0,0,.66-.52,30.05,30.05,0,0,0,.53-3.38,10.89,10.89,0,0,0,1.65-.7l2.52,2a.9.9,0,0,0,.47.17c.27,0,.84-.43,1.71-1.3a18.05,18.05,0,0,0,1.81-2,.59.59,0,0,0,.16-.41.72.72,0,0,0-.18-.46q-1.3-1.6-1.95-2.52a11.61,11.61,0,0,0,.71-1.65l3.37-.51a.6.6,0,0,0,.37-.24.73.73,0,0,0,.14-.42v-4A.74.74,0,0,0,68.85,40.92ZM55,49.21a5.88,5.88,0,1,1,5.88-5.88A5.88,5.88,0,0,1,55,49.21Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDefault);
export default __webpack_public_path__ + "static/media/service-default.2d11323d770da1076c91c751874f4c5f.svg";
export { ForwardRef as ReactComponent };